'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _ramda = require('ramda');

var _card_component = require('./global_components/card_component');

var _card_component2 = _interopRequireDefault(_card_component);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var RegisteredCountryComponent = function (_React$PureComponent) {
  _inherits(RegisteredCountryComponent, _React$PureComponent);

  function RegisteredCountryComponent(props) {
    _classCallCheck(this, RegisteredCountryComponent);

    var _this = _possibleConstructorReturn(this, (RegisteredCountryComponent.__proto__ || Object.getPrototypeOf(RegisteredCountryComponent)).call(this, props));

    _this.renderData = _this.renderData.bind(_this);
    return _this;
  }

  _createClass(RegisteredCountryComponent, [{
    key: 'renderPrintDisclosures',
    value: function renderPrintDisclosures() {
      return _react2.default.createElement(
        'div',
        { 'data-testid': 'print-disclosures', className: 'print-display', style: { "display": "none" } },
        this.props.disclosure && _react2.default.createElement('div', { className: 'font-slate-grey disclosure disclaimer print-page-break margin-bottom-15 text-justified',
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.disclosure) } })
      );
    }
  }, {
    key: 'renderRow',
    value: function renderRow(data) {
      var _this2 = this;

      var markupArr = [];
      mapIndexed(function (item, index) {
        var row = [];
        var effectiveDate = (0, _ramda.isNil)(item.effectiveDate) ? '-' : _date_formatter2.default.getLocalFormattedDate(item.effectiveDate);
        row.push(_react2.default.createElement(
          'div',
          { key: 'country-row-' + index, 'data-testid': 'registration-country-' + index, className: (_this2.props.breakpoint < 3 ? 'width-percent-50' : 'width-percent-75') + ' display-inline-block' },
          _react2.default.createElement(
            'span',
            { className: '' },
            item.country
          )
        ));
        row.push(_react2.default.createElement(
          'div',
          { key: 'date-row-' + index, 'data-testid': 'registration-date-' + index, className: (_this2.props.breakpoint < 3 ? 'width-percent-50' : 'width-percent-25') + ' display-inline-block text-right' },
          _react2.default.createElement(
            'span',
            { className: '' },
            effectiveDate
          )
        ));
        markupArr.push(_react2.default.createElement(
          'div',
          { 'data-testid': 'registered-country-row', key: 'registered-country-row-' + index, className: "row-divider" },
          row
        ));
      }, data);
      return markupArr;
    }
  }, {
    key: 'renderData',
    value: function renderData() {
      var data = this.props.data;
      if (data.length < 2 || this.props.breakpoint < 3) {
        return _react2.default.createElement(
          'div',
          { 'data-testid': 'one-col-layout', className: 'category' },
          _react2.default.createElement(
            'div',
            null,
            this.renderRow(data)
          )
        );
      }

      var dataArr = (0, _ramda.splitAt)(Math.round(this.props.data.length / 2), data);
      return _react2.default.createElement(
        'div',
        { 'data-testid': 'two-col-layout', className: 'category with-disclosure' },
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block width-percent-48 text-top' },
          this.renderRow(dataArr[0])
        ),
        _react2.default.createElement('div', { className: 'display-inline-block width-percent-4 text-top' }),
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block width-percent-48 text-top' },
          this.renderRow(dataArr[1])
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if ((0, _ramda.isNil)(this.props.data) || (0, _functional_utility.isDataEmpty)(this.props.data)) {
        return null;
      }

      var containsMissingDate = _collection_utility.CollectionUtility.find(this.props.data, function (item) {
        return (0, _ramda.isNil)(item.effectiveDate);
      });

      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: 'fund-registered-countries-card',
          headerTitle: _string_utility2.default.renderFormattedLabel("Registered countries", "pdp-overview-registered-countries-header-label"),
          headerTitleId: 'fund-registered-countries-title',
          breakpoint: this.props.breakpoint,
          disclosureText: this.props.disclosure,
          placementId: !(0, _ramda.isNil)(containsMissingDate) ? 'pdpCardRegisteredCountries' : null,
          hideDisclosureinCardForPrintView: true,
          isDisclosureAbsent: (0, _ramda.isNil)(this.props.disclosure)
        },
        this.renderData(),
        _react2.default.createElement(
          'div',
          { 'data-testid': 'registered-country-comp-print-disclosure' },
          this.renderPrintDisclosures()
        )
      );
    }
  }]);

  return RegisteredCountryComponent;
}(_react2.default.PureComponent);

exports.default = RegisteredCountryComponent;